import React from 'react';
import * as lang from '../../../../Constants/strings';
import CustomModal from '../../../../Components/Modals/CustomModal';
import { useMediaQuery, useTheme, Grid } from '@material-ui/core';
import TaskNewForm from '../TaskNewForm';


export default function AddTaskModal(props) {
    const theme = useTheme();
    const tiny = useMediaQuery(theme.breakpoints.down('xs'));
    const { language, open, close, validate, addData, executeFunction, baseData } = props;

    return (
        <CustomModal
            fullWidth
            open={open}
            title={lang.ADD_TASK[language]}
            content={
                <Grid container spacing={2}>
                    {open ?
                        <TaskNewForm
                            {...props}
                            addData={addData}
                            baseData={baseData}
                            tiny={tiny}
                        />
                        : null
                    }
                </Grid>
            }
            close={close}
            execute={() => {
                executeFunction();
                close();
            }}
            language={language}
            validate={validate}
        />
    )
}